import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function ValueStack() {
  const items = ['El Sistema Mamá IA (El mapa paso a paso)', 'Biblioteca de Prompts Maestros (Para que la IA trabaje por ti)', 'Guía de Visuales Faceless (Para vender sin mostrar tu cara)'];
  return <section id="oferta" className="bg-white py-16 md:py-24 px-4 border-t border-slate-100" data-id="element-231">
      <div className="max-w-3xl mx-auto" data-id="element-232">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-[32px] p-8 md:p-12 shadow-2xl border-2 border-primary relative overflow-hidden" data-id="element-233">
          <div className="absolute top-0 left-0 right-0 bg-primary text-white text-center py-2 font-bold text-sm tracking-widest uppercase" data-id="element-234">
            OFERTA ESPECIAL DE LANZAMIENTO
          </div>

          <div className="text-center mt-8 mb-8" data-id="element-235">
            <h2 className="text-3xl md:text-4xl text-dark font-display font-extrabold tracking-headline mb-2" data-id="element-236">
              Sistema Mamá IA
            </h2>
            <p className="text-slate-500" data-id="element-237">
              La <strong className="text-dark" data-id="element-238">tecnología más simple</strong>{' '}
              para crear tu primer producto digital
            </p>
          </div>

          <div className="bg-slate-50 rounded-2xl p-6 mb-8 border border-slate-200" data-id="element-239">
            <h3 className="font-bold text-dark mb-4" data-id="element-240">Estás comprando:</h3>
            <ul className="space-y-4" data-id="element-241">
              {items.map((item, idx) => <li key={idx} className="flex items-center gap-3" data-id="element-242">
                  <div className="bg-green-100 p-1 rounded-full flex-shrink-0" data-id="element-243">
                    <Check className="w-4 h-4 text-green-600" data-id="element-244" />
                  </div>
                  <span className="text-dark font-medium" data-id="element-245">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="text-center mb-8" data-id="element-246">
            <div className="inline-block bg-green-100 text-green-800 font-bold px-3 py-1 rounded-full text-xs mb-2" data-id="element-247">
              93% OFF
            </div>
            <p className="text-slate-400 font-medium mb-1 line-through text-lg" data-id="element-248">
              Valor Normal: $19.99 USD
            </p>
            <div className="flex items-center justify-center gap-2" data-id="element-249">
              <span className="text-5xl md:text-6xl text-primary font-display font-black tracking-tighter" data-id="element-250">
                $6.36
              </span>
              <span className="text-xl font-bold text-slate-400 mt-4" data-id="element-251">USD</span>
            </div>
            <p className="text-slate-500 text-sm mt-2" data-id="element-252">
              Pago único · Sin suscripciones
            </p>
          </div>

          <motion.a href="https://www.vitarutinas.com/cart/50347583471862:1" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart()} className="shimmer-cta block w-full bg-primary hover:bg-primary/90 text-white font-bold rounded-2xl px-8 py-5 text-lg md:text-xl shadow-lg shadow-primary/25 text-center relative overflow-hidden" animate={{
          scale: [1, 1.02, 1]
        }} transition={{
          duration: 2,
          repeat: Infinity,
          ease: 'easeInOut'
        }} whileHover={{
          scale: 1.03
        }} whileTap={{
          scale: 0.97
        }} data-id="element-253">
            ¡Lanza Tu Negocio En 7 Días! - $6.36
          </motion.a>

          <div className="mt-6 space-y-3" data-id="element-254">
            <div className="flex items-center justify-center gap-2" data-id="element-255">
              <svg className="h-4 w-4 text-green-500" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-256">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" data-id="element-257" />
                <path d="m9 12 2 2 4-4" data-id="element-258" />
              </svg>
              <span className="text-slate-400 text-xs font-semibold uppercase tracking-wider" data-id="element-259">
                Pago 100% Seguro
              </span>
            </div>
            <div className="flex items-center justify-center gap-3" data-id="element-260">
              {/* Visa */}
              <svg className="h-8" viewBox="0 0 780 500" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-261">
                <rect width="780" height="500" rx="40" fill="#f7f7f7" stroke="#e2e8f0" strokeWidth="4" data-id="element-262" />
                <path d="M293.2 348.7l33.4-195.7h53.4l-33.4 195.7h-53.4zm224.5-190.9c-10.6-4-27.2-8.3-47.9-8.3-52.8 0-90 26.6-90.2 64.7-.3 28.2 26.6 43.9 46.9 53.3 20.8 9.6 27.8 15.8 27.7 24.4-.1 13.2-16.6 19.2-32 19.2-21.4 0-32.7-3-50.3-10.2l-6.9-3.1-7.5 43.8c12.5 5.5 35.6 10.2 59.6 10.5 56.2 0 92.6-26.3 93-67.1.2-22.3-14.1-39.3-45-53.3-18.7-9.1-30.2-15.1-30.1-24.3 0-8.1 9.7-16.8 30.7-16.8 17.5-.3 30.2 3.5 40.1 7.5l4.8 2.3 7.3-42.6zm138.3-4.8h-41.3c-12.8 0-22.4 3.5-28 16.3l-79.4 179.4h56.2s9.2-24.1 11.3-29.4h68.6c1.6 6.9 6.5 29.4 6.5 29.4h49.7l-43.6-195.7zm-65.8 126.4c4.4-11.3 21.4-54.8 21.4-54.8-.3.5 4.4-11.4 7.1-18.8l3.6 17s10.3 47 12.5 56.6h-44.6zM285.5 153l-52.3 133.6-5.6-27.2c-9.7-31.2-39.9-65-73.7-81.9l47.9 171.1 56.6-.1 84.2-195.5h-57.1z" fill="#1a1f71" data-id="element-263" />
                <path d="M146.9 153h-86.4l-.7 3.8c67.1 16.2 111.5 55.4 129.9 102.4l-18.7-90c-3.2-12.3-12.6-15.8-24.1-16.2z" fill="#f9a533" data-id="element-264" />
              </svg>
              {/* Mastercard */}
              <svg className="h-8" viewBox="0 0 780 500" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-265">
                <rect width="780" height="500" rx="40" fill="#f7f7f7" stroke="#e2e8f0" strokeWidth="4" data-id="element-266" />
                <circle cx="330" cy="250" r="130" fill="#eb001b" data-id="element-267" />
                <circle cx="450" cy="250" r="130" fill="#f79e1b" data-id="element-268" />
                <path d="M390 148.4A129.7 129.7 0 00330 250a129.7 129.7 0 0060 101.6A129.7 129.7 0 00450 250a129.7 129.7 0 00-60-101.6z" fill="#ff5f00" data-id="element-269" />
              </svg>
              {/* Amex */}
              <svg className="h-8" viewBox="0 0 780 500" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-270">
                <rect width="780" height="500" rx="40" fill="#2e77bc" data-id="element-271" />
                <text x="390" y="270" textAnchor="middle" fontFamily="Arial, sans-serif" fontWeight="bold" fontSize="120" fill="white" data-id="element-272">
                  AMEX
                </text>
              </svg>
              {/* PayPal */}
              <svg className="h-8" viewBox="0 0 780 500" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-273">
                <rect width="780" height="500" rx="40" fill="#f7f7f7" stroke="#e2e8f0" strokeWidth="4" data-id="element-274" />
                <text x="390" y="270" textAnchor="middle" fontFamily="Arial, sans-serif" fontWeight="bold" fontSize="110" fill="#003087" data-id="element-275">
                  Pay
                </text>
                <text x="560" y="270" textAnchor="middle" fontFamily="Arial, sans-serif" fontWeight="bold" fontSize="110" fill="#009cde" data-id="element-276">
                  Pal
                </text>
              </svg>
            </div>
            <div className="flex justify-center" data-id="element-277"></div>
          </div>
        </motion.div>
      </div>
    </section>;
}